export default __webpack_public_path__ + "static/media/publicViewIcon.ae92c610.svg";